/* eslint-disable no-undef */
import '../css/SemanticMenu.scss'
import { upperFirstLetter } from '../scripts/utils'
import { amber, grey, red, teal } from '@material-ui/core/colors'
import {
  MicRounded,
  BackspaceRounded,
  ControlCameraRounded,
  ContentCopy,
  BookRounded,
  CreateRounded,
} from '@material-ui/icons'
import {
  ControlledMenu,
  MenuItem,
  MenuDivider,
  MenuHeader,
} from '@szhsin/react-menu'
import '@szhsin/react-menu/dist/index.css'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class SemanticMenu extends PureComponent {
  constructor() {
    super()
    this.state = {
      isOpen: false,
      anchorPointX: -100,
      anchorPointY: -100,
    }
  }

  componentDidUpdate() {
    this.setState(prevState => {
      let newState = { ...prevState }

      newState.isOpen = this.props.text.length !== 0 && !this.props.inSelecting
      const currentNode = this.props.blockRef.current
      if (currentNode) {
        const { x, y } = getAnchorPointXY(currentNode.getBoundingClientRect())
        newState.anchorPointX = x
        newState.anchorPointY = y
      } else {
        newState.anchorPointX = -100
        newState.anchorPointY = -100
      }

      return newState
    })
  }

  render() {
    const { isOpen, anchorPointX, anchorPointY } = this.state

    const menuItems = []
    ;['replace', 'delete', 'move', 'copy'].forEach(item => {
      const ThisIcon = itemMapping[item][0]
      addToMenuItems(menuItems, item, ThisIcon)
    })

    menuItems.push(<MenuDivider key="divider-1" />)
    menuItems.push(
      <MenuHeader key="header-1" className="s-menu-header">
        Semantic Options
      </MenuHeader>
    )
    ;['translate', 'highlight'].forEach(item => {
      const ThisIcon = itemMapping[item][0]
      addToMenuItems(menuItems, item, ThisIcon)
    })

    return (
      <>
        <ControlledMenu
          anchorPoint={{
            x: anchorPointX,
            y: anchorPointY,
          }}
          isOpen={isOpen}
          onClose={() => {
            this.setState({ isOpen: false })
          }}
          className="semantic-menu"
        >
          {menuItems}
        </ControlledMenu>
      </>
    )
  }
}

SemanticMenu.propTypes = {
  text: PropTypes.string,
  inSelecting: PropTypes.bool,
  blockRef: PropTypes.object,
}

/* -------------------------------------------------------------------------- */

const addToMenuItems = (menuItems, item, ThisIcon) => {
  menuItems.push(
    <MenuItem key={item} className="s-menu-item">
      <ThisIcon
        className={`s-menu-icon s-menu-icon-${item}`}
        style={itemMapping[item][1]}
      />
      {upperFirstLetter(item)}
    </MenuItem>
  )
}

/* -------------------------------------------------------------------------- */

const iconStyles = {
  fill: grey[400],
}

// [icon, iconStyle]
const itemMapping = {
  replace: [MicRounded, { ...iconStyles }],
  delete: [BackspaceRounded, { ...iconStyles }],
  move: [ControlCameraRounded, { ...iconStyles }],
  copy: [ContentCopy, { ...iconStyles }],
  // Semantic
  translate: [BookRounded, { ...iconStyles, fill: teal[500] }],
  highlight: [CreateRounded, { ...iconStyles, fill: amber[500] }],
}

/* -------------------------------------------------------------------------- */

const getAnchorPointXY = ({ left, top, bottom, right }) => {
  const returner = { x: 0, y: 0 }
  if (screen.width - left < 170) returner.x = right
  else returner.x = left

  // TODO Adjust for screen bottom cases
  // if (screen.height - bottom < 252 + 20) returner.y = top - 20 - 252
  // else returner.y = bottom + 20
  returner.y = bottom + 20

  return returner
}
